import { useIsAuthenticated } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import StartButton from "../components/StartButton";
import RegisterButton from "../components/RegisterButton";
import { getToast } from "../services/systemService";
import { toast } from "react-toastify";
import { StartupPageTemplate } from "../components/startup-pages/StartupPageTemplate";
import { toastConfig } from "../configs/toastConfig";

export default function StartPage({ forceRefresh }) {
	const [isAuthenticated] = useState(useIsAuthenticated());

	useEffect(() => {
		let timer;

		timer = setTimeout(() => {
			timer = null;
			const toastMessage = getToast();
			if (toastMessage && toastMessage.message) {
				let options = {
					type: "info",
					hideProgressBar: true,
					autoClose: false,
					pauseOnHover: false,
					pauseOnFocusLoss: false,
				};

				let message;
				if (typeof toastMessage.message === "string") {
					message = toastMessage.message;
				} else {
					const ms = toastMessage.message.map((m) => {
						return <p className="mb-2">{m}</p>;
					});

					message = <div>{ms}</div>;
				}

				options = { ...options, ...(toastMessage.options || {}) };
				toast(<>{message}</>, options);
			} else if (toastMessage) {
				toast.error(toastMessage, {
					toastId: toastConfig.toastIds.errLogin,
				});
			}
		}, 500);

		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
	}, []);

	let body;

	if (isAuthenticated) {
		body = <p>You are signed in</p>;
	} else {
		body = (
			<>
				<p className={"mb-3 text-sm md:text-base text-center"}>
					Already have an account?
					<br />
					Sign in to access your account
				</p>
				<StartButton forceRefresh={forceRefresh} />
				<p className={"mt-6 mb-3 text-sm md:text-base text-center"}>
					No account?
					<br />
					Register to set up an account
				</p>
				<RegisterButton />
			</>
		);
	}

	return <StartupPageTemplate>{body}</StartupPageTemplate>;
}
